//cart free product quantity set 1
/*$(document).ready(function(){
      setInterval(function(){
         $('.FreeProduct').each(function(){
           var freeproqut = $(this).find('.CartItem__QuantitySelector .QuantitySelector__CurrentQuantity').val();
           if(freeproqut > 1){
             $(this).find('.QuantitySelector__CurrentQuantity').val('1').change();
             freeproqut--;
           }
         });
      }, 80);
    });*/
    
$(window).load(function(){
  $('.js-campaign-banner-slider').on('init', function(event, slick){
    document.documentElement.style.setProperty('--announcement-bar-height', document.getElementById('shopify-section-announcement').offsetHeight + 'px');
  });
      if ((window.innerWidth <= 480 )){
                $('.js-campaign-banner-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
                  if(nextSlide === 1){
                    $('#shopify-section-header').css("top","40px");
                    $('.SidebarMenu').css("margin-top","98px");
                  }
                  else{
                    $('#shopify-section-header').css("top",'');
                    $('.SidebarMenu').css("margin-top",'90px');
                  }
          });
      }
      $('.js-campaign-banners-slider').slick({
        draggable: true,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        dots: false,
        fade: true,
        speed: 500,
        infinite: true,
    	pauseOnHover: false,
        cssEase: 'ease-in-out',
        touchThreshold: 100
     });
    });  
    
$('[aria-hidden="true"]').attr('tabindex',-1);

$('[data-action="close-drawer"][data-drawer-id="sidebar-cart"]').click(function(){
  $("#sidebar-cart").attr("aria-hidden",true);
  $("html").removeClass("no-scroll");
});

$('.ProductIngre_TabList a').attr('role','link');
$('.ProductIngre_TabList a').attr('tabindex','0');

$('.CollectionFilter_Custom .CollectionToolbar__Item').click(function(){
   var popup_id = $(this).attr('aria-controls');
   
  //$('#'+popup_id).attr('aria-hidden','false');
  //$('body').addClass('no-scroll');
  if($('#'+popup_id).attr('aria-hidden')==='true' && $(this).attr('aria-expanded') === 'false'){
           $('div:not(#' + popup_id +')').attr('aria-hidden','true');
           $('#'+popup_id).attr('aria-hidden','false');
          $(this).attr('aria-expanded','true');
          $('.CollectionToolbar__Item[aria-controls !="'+popup_id+'"]').attr('aria-expanded','false');
    }
   else{
            $('#'+popup_id).attr('aria-hidden','true');    
            $(this).attr('aria-expanded','false');
    }
});

$('.CollectionFilter__Tag .Linklist__Item').click(function(){
   var popup_id = $(this).parent().parent().parent().parent().parent().parent().parent().attr('id');
   
  if($('#'+popup_id).attr('aria-hidden')==='true'|| $('.CollectionToolbar__Item[aria-controls="'+popup_id+'"]').attr('aria-expanded') === 'false'){
           $('#'+popup_id).attr('aria-hidden','false');
         $('.CollectionToolbar__Item[aria-controls="'+popup_id+'"]').attr('aria-expanded','true');
    }
   else{
            $('#'+popup_id).attr('aria-hidden','true');           
           $('.CollectionToolbar__Item[aria-controls="'+popup_id+'"]').attr('aria-expanded','false');
    }
});

/* Mobile search Form Submit */

$('.SidebarMenu__Search .Search__InputIconWrapper').click(function(){
  $('.Search__Form')[0].submit();
});
$('.Header__Icon[data-drawer-id="sidebar-menu"]').click(function(){
 $('html,body').addClass("menu--open");
});
$('.Header__Icon--close').click(function(){
 $('html,body').removeClass("menu--open");
});
  $('.CollectionFilter__Tag ul.Linklist li.Linklist__Item button').click(function(){
    $('.CollectionFilter__Tag li.Linklist__Item button').removeClass("active");
    $(this).addClass("active");
});

/* Vertical Tab script */

  $('.ProductIngre_TabList li').on('click', function() {
    show_content($(this).index());
  });
  
  show_content(0);

  function show_content(index) {
    // Make the content visible
    $('.ProductIngre_TabPanel.visible').removeClass('visible');
    $('.ProductIngre_TabPanel:nth-of-type(' + (index + 1) + ')').addClass('visible');

    // Set the tab to selected
    $('.ProductIngre_TabList li.selected').removeClass('selected');
    $('.ProductIngre_TabList li:nth-of-type(' + (index + 1) + ')').addClass('selected');
  }

/*----- Convert Tab into DropDown -----------*/
jQuery(function( $ ) {
    $.fn.tabConvert = function(options) {
    
        var settings = $.extend({
            activeClass: "active",
            screenSize: 1007,
        }, options );

        return this.each(function(i) {
            var wrap = $(this).wrap('<div class="TabtoDropdown"></div>'),
                    currentItem = $(this),
                    container = $(this).closest('.TabtoDropdown'),
                    value = $(this).find('.'+settings.activeClass).text(),
                    toggler = '<div class="selected-tab u-h2 FontWeight_Six">'+ value +'</div>';
            currentItem.addClass('converted-tab');
            container.prepend(toggler);
            
            // function to slide dropdown
            function tabConvert_toggle(){
                currentItem.parent().find('.converted-tab').slideToggle();
            }

            container.find('.selected-tab').click(function(){
                $(this).toggleClass('is-opened');
                tabConvert_toggle();
            });
            
            currentItem.find('.TabList__Item').click(function(e){
                var windowWidth = window.innerWidth;
                if( settings.screenSize >= windowWidth){
                    tabConvert_toggle();
                    var selected_text = $(this).text();
                    $(this).closest('.TabtoDropdown').find('.selected-tab').text(selected_text);
                }
            });
            
            //Remove toggle if screen size is bigger than defined screen size
            function resize_function(){
                var windowWidth = window.innerWidth;
                if( settings.screenSize >= windowWidth){
                    currentItem.css('display','none');
                    currentItem.parent().find('.selected-tab').css('display','');
                }else{
                    currentItem.css('display','');
                    currentItem.parent().find('.selected-tab').css('display','none');
                }
            }
            resize_function();
            
            $(window).resize(function(){
                resize_function();
            });
            
        });
    };

    //  Toggle will appear on default screen size 767px
    $('.Subscription_TabList').tabConvert({
    activeClass: "is-active",
    });
    /*$('.ProductIngre_TabList').tabConvert({
    activeClass: "selected",
    });*/

}( jQuery ));

/*-------- Section Show On scroll ---------*/
var circles = document.querySelectorAll(".AboutTimeline__Section");
function elementInView(el) {
  // The vertical distance between the top of the page and the top of the element.
  var elementOffset = $(el).offset().top;
  // The height of the element, including padding and borders.
  var elementOuterHeight = $(el).outerHeight();
  // Height of the window without margins, padding, borders.
  var windowHeight = $(window).height();
  // The vertical distance between the top of the page and the top of the viewport.
  var scrollOffset = $(this).scrollTop();

  if (elementOuterHeight < windowHeight) {
    // Element is smaller than viewport.
    if (scrollOffset > (elementOffset + elementOuterHeight - windowHeight)) {
      // Element is completely inside viewport, reveal the element!
      return true;
    }
  } else {
    // Element is larger than the viewport, handle visibility differently.
    // Consider it visible as soon as it's top half has filled the viewport.
    if (scrollOffset > elementOffset) {
      // The top of the viewport has touched the top of the element, reveal the element!
      return true;
    }
  }
  return false;
}
function handler() {
  for (var i = 0; i < circles.length; i++) {
    if (elementInView(circles[i])) {
      circles[i].classList.add("in-view");
    }
  }
}
$(window).on('DOMContentLoaded load resize scroll', handler);

$(window).on('load', function(){
  var backButton = '<button class="slide-arrow prev-arrow"><svg width="15px" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-chevron-right fa-w-10 fa-3x chevron--left"><path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" class=""></path></svg></button>';
  var nextButton = '<button class="slide-arrow next-arrow"><svg width="15px" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-chevron-right fa-w-10 fa-3x chevron--right"><path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" class=""></path></svg></button>'
	$('.TableList').slick({
          dots: true,
          arrows: true,
          slidesToShow: 1,
          draggable: false,
          responsive: [{
              breakpoint: 767,
              settings: {
                  centerMode: false,
                  draggable: true,
                  slidesToShow: 1,
                  variableWidth: false,
                  mobileFirst: true,
                  adaptiveHeight: true,
                  prevArrow: backButton,
                  nextArrow: nextButton
              }
          }]
      }); 
});

jQuery(function($){
$('.recommondation_dropdown').change(function(event){
   if ($(this).val() !== "") {
      event.preventDefault();
         // Store hash
         var hash = $(this).val();
         $('html, body').animate({
            scrollTop: $(hash).offset().top - 50
         }, 1000, function(){
         // Add hash (#) to URL when done scrolling (default click behavior)
         //window.location.hash = hash;
      });
   } 
});
});

$(window).scroll(function(){
  var scroll = $(window).scrollTop();
  if (scroll >= 31) $('body').addClass('scroll--topbar');
  else $('body').removeClass('scroll--topbar');
});

$('.nav-tabs li a').click(function (e) { 
    e.preventDefault();
    //get selected href
    var href = $(this).attr('href');    
    //set all nav tabs to inactive
    $('.nav-tabs li').removeClass('active');
    //get all nav tabs matching the href and set to active
    $('.nav-tabs li a[href="'+href+'"]').closest('li').addClass('active');
    //active tab
    $('.tab-pane').removeClass('active');
    $('.tab-pane'+href).addClass('active');
    return false;
});

$(window).scroll(function(){
  var scroll = $(window).scrollTop();
  if (scroll >= 900) $('body').addClass('show_sticky');
  else $('body').removeClass('show_sticky');
});

$(document).ready(function() {
  $('.Col__Actions').on( "click", '.Sticky_AddtoCartButton', function(e){
    $('.ProductForm__AddToCart').trigger(e.type);
     return false;
});
  });

/* Sticky Cart */
$(function () {
    $('.Sticky_SubscribeLeft .Sticky_HeaderSubscribe').addClass('Sticky_Darktext');
    $('.Sticky_SubscribeLeft .Sticky_HeaderFreeshipping').addClass('Sticky_Darktext');
    $('.Sticky_PriceRight').addClass('Subscription_Price');
     $('.sticky_toggleInput').on('change', function() {
	  var mainParent = $(this).parent('.switch');
	  if($(mainParent).find('.sticky_toggleInput').is(':checked')) {
		$('.Sticky_SubscribeRight .Sticky_HeaderSubscribe').addClass('Sticky_Darktext');
        $('.Sticky_SubscribeLeft .Sticky_HeaderSubscribe').removeClass('Sticky_Darktext');
        $('.Sticky_SubscribeLeft .Sticky_HeaderFreeshipping').removeClass('Sticky_Darktext');
        $('.Sticky_PriceRight').addClass('Subscription_Price');
        $('.Sticky_PriceLeft').removeClass('Subscription_Price');
	  }else{
		$('.Sticky_SubscribeLeft .Sticky_HeaderSubscribe').addClass('Sticky_Darktext');
        $('.Sticky_SubscribeLeft .Sticky_HeaderFreeshipping').addClass('Sticky_Darktext');
        $('.Sticky_SubscribeRight .Sticky_HeaderSubscribe').removeClass('Sticky_Darktext');
        $('.Sticky_PriceLeft').addClass('Subscription_Price');
        $('.Sticky_PriceRight').removeClass('Subscription_Price');
	  }
     });
   });

$(document).ready(function() {
 
                $('.sticky_toggleInput').change(function() {
                    if ($(this).is(':checked')) {
                        $('.onetime-radio').trigger('click');
                        //$('.rc_block__type__onetime').addClass('active');
                    } else {
                        $('.subscription-radio').trigger('click');
                        //$('.rc_block__type__autodeliver').addClass('active');
                    }
                })
 
            });

$('#sidebar-menu .Linklist__Item a, .Drawer__Product .ProductList .ProductItem__Wrapper a').on('click',function(){
    setTimeout(function(){
         $('.Header__Icon[data-drawer-id="sidebar-menu"]').trigger('click');
    },200)
});

/* Quantity Selector */

$(document).ready(function() {
var input = document.querySelector('#qty');
var btnminus = document.querySelector('.qtyminus');
var btnplus = document.querySelector('.qtyplus');

if (input !== undefined && btnminus !== undefined && btnplus !== undefined && input !== null && btnminus !== null && btnplus !== null) {
	
	var min = Number(input.getAttribute('min'));
	var max = Number(input.getAttribute('max'));
	var step = Number(input.getAttribute('step'));

	function qtyminus(e) {
		var current = Number(input.value);
		var newval = (current - step);
		if(newval < min) {
			newval = min;
		} else if(newval > max) {
			newval = max;
		} 
		input.value = Number(newval);
		e.preventDefault();
	}

	function qtyplus(e) {
		var current = Number(input.value);
		var newval = (current + step);
		if(newval > max) newval = max;
		input.value = Number(newval);
		e.preventDefault();
	}
		
	btnminus.addEventListener('click', qtyminus);
	btnplus.addEventListener('click', qtyplus);
  
}
$('.qtyminus').click(function (){
    var input_val = $(this).next().val();
    $('.quantity_item[data-quantity='+input_val+']').trigger('click');
})
$('.qtyplus').click(function (){
    var input_val = $(this).prev().val();
    $('.quantity_item[data-quantity='+input_val+']').trigger('click');
})
 })

var product_ttl = GetURLParameter('utm_content');
if(product_ttl !== "undefined" && product_ttl === 'bobby_parrish'){
     $('body').addClass('with--utmparameter');
    }
// searving popup and review popup
$(window).on('load', function () {
  $(".pt_414-tooltip").click(function (e) {
                    e.stopPropagation();
                  
                    var $tooltipText = $(this).find(".pt_414-tooltiptext");
                    if ($tooltipText.is(":visible")) {
                      $tooltipText.hide();
                    } else {
                      $(".pt_414-tooltiptext").hide();
                      $tooltipText.show();
                    }
                  });
       if(window.innerWidth <= 768 ){
               $(".info-icon-servings").click(function(e) {
                   $(this).siblings('.details').toggleClass('show');
                   e.stopPropagation();
                 });
               $(".ProductItem__Rating .oke-sr-count").click(function(e) {
                   $(this).parents('[data-oke-star-rating]').siblings(".reviews").toggleClass('show');
                 });
                 $(".pt_342_close_button")
                   .click(function() {
                     $(this).parents(".reviews").removeClass("show"); 
                   });
              $(document).on("click touchstart", function(e) {
      // Check if the clicked/touched element is NOT inside .reviews
      if ($(e.target).closest(".reviews").length === 0) {
        $(".reviews").removeClass("show");
      }
    });
               window.onscroll = function (e) {  
                  var sidebar = $('.details');
                  var reviewpopup = $('.reviews');
                  if(sidebar.hasClass('show'))
                      {
                          sidebar.removeClass('show');
                      }
                  if(reviewpopup.hasClass('show'))
                      {
                          reviewpopup.removeClass('show');
                      }
                  } 
               } else {
                 $(".pt_342_close_button")
                   .click(function() {
                     $(this).parents(".reviews").removeClass("show"); 
                   });
                 $(".info-icon-servings")
                   .mouseenter(function() {
                     $(this).siblings(".details").addClass("show"); 
                   })
                   .mouseleave(function() {
                      $(this).siblings(".details").removeClass("show"); 
                   });
                $(".ProductItem__Rating")
                   .mouseenter(function() {
                     console.log('enter');
                     $(this).find(".reviews").addClass("show"); 
                   })
                   .mouseleave(function() {
                      $(this).find(".reviews").removeClass("show"); 
                   });
             }
   });

   document.addEventListener("click", function (e) {
  const continueBtn = e.target.closest(".lion-referral-modal--continue--button");
  if (continueBtn) {
    e.preventDefault();            // stop browser navigation
    e.stopImmediatePropagation();  // stop LoyaltyLion handler

    // Click the copy button
    const copyBtn = document.querySelector(".lion-copy-to-clipboard-button");
    if (copyBtn) {
      copyBtn.click();
      console.log("Coupon copied from Continue button");
    }

    // (Optional) Close modal after copy
    const closeBtn = document.querySelector(".lion-modal__close-button");
    if (closeBtn) closeBtn.click();
  }
}, true); // 👈 capture phase!

(function ($) {

  function initCartDrawerSlider() {
    if (window.innerWidth <= 768) return;

    const $productList = $('.cart_Drawer_product .ProductList');

    if (!$productList.length) return;
    if ($productList.hasClass('slick-initialized')) return;
    if (typeof $.fn.slick !== 'function') return;

    $productList.slick({
      slidesToShow: 2.5,
      slidesToScroll: 1,
      infinite: false,
      arrows: false,
      dots: false,
      draggable: true,
      swipeToSlide: true,
      touchMove: true,
      speed: 400,
      cssEase: 'ease'
    });
  }

  const cartObserver = new MutationObserver(() => {
    initCartDrawerSlider();
  });

  cartObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

})(jQuery);

